<script>
import { ElMessage } from 'element-plus'
import { chongZhiApi, getJiaMengShangListApi, getRecordListApi } from '../api/sms'
import { rfcToTime } from '../utils/defaultTime'

  export default {
    name: 'AddSms',
    data() {
      return {
        tableData: [],
        page: 1,
        total: 0,
        chongZhiVisible: false,
        form: {
          companyId: '',
          quantity: '',
          desc: ''
        },
        recordVisible: false,
        recordPage: 1,
        recordTotal: 0,
        companyId: null,
        recordData: []
      }
    },
    methods: {
      async getTableData(){
        const params = {
          page: this.page,
          pageSize: 10
        }
        const res = await getJiaMengShangListApi(params)
        if(res.code == 0){
          this.total = res.data.total
          this.tableData = res.data.list
        }else {
          this.total = 0
          this.tableData = []
          ElMessage.error(res.msg)
        }
      },
      handleChongZhiDialogClosed(){
        this.form.companyId = ''
        this.form.quantity = ''
        this.form.desc = ''
      },
      handleRestForm(){
        this.form.quantity = ''
        this.form.desc = ''
      },
      chongZhi(row) {
        this.form.companyId = row.id
        this.chongZhiVisible = true
      },
      async submitForm(){
        if(!this.form.quantity) return ElMessage.error('请先填写信息')
        this.form.quantity = Number(this.form.quantity)
        const res = await chongZhiApi(this.form)
        if(res.code == 0){
          ElMessage.success('充值成功')
          this.chongZhiVisible = false
          this.getTableData()
        }else {
          ElMessage.error(res.msg)
        }
      },
      async getRecordList(){
        const params = {
          page: this.recordPage,
          pageSize: 10,
          companyId: this.companyId
        }
        const res = await getRecordListApi(params)
        if(res.code == 0 && res.data.list && res.data.list.length > 0){
          this.recordTotal = res.data.total
          res.data.list.forEach(item => {
            item.CreatedAt = rfcToTime(item.CreatedAt)
          });
          this.recordData = res.data.list
        }else {
          this.recordData = []
          this.recordTotal = 0
        }
      },
      async record(row){
        this.companyId = row.id
        this.recordPage = 1
        this.recordVisible = true
        await this.getRecordList()
      },
      handleRecordDialogClosed(){
        this.recordTotal = 0
        this.recordData = []
        this.companyId = null
      },
      currentChange(){
        this.getRecordList()
      }

    },
    watch: {
      page: {
        handler(){
          this.getTableData()
        },
        immediate: true
      },
    }
  }
</script>

<template>
  <div style="box-sizing: border-box; background: white; padding: 20px;">
    <el-table :data="tableData" style="border: 1px solid #efefef;">
      <el-table-column prop="id" label="ID" />
      <el-table-column prop="name" label="加盟商名称" />
      <el-table-column prop="useQuantity" label="短信使用条数" />
      <el-table-column prop="remainingQuantity" label="短信剩余条数" />
      <el-table-column prop="totalQuantity" label="短信总条数" />
      <el-table-column label="操作">
        <template #default="{row}">
          <el-button type="primary" size="mini" @click="chongZhi(row)">充值</el-button>
          <el-button type="info" size="mini" @click="record(row)">记录</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: center; margin-top: 20px;">
      <el-pagination background layout="prev, pager, next" hide-on-single-page :total="total" v-model:current-page="page" />
    </div>
    <el-dialog title="充值" v-model="chongZhiVisible" @closed="handleChongZhiDialogClosed">
      <el-form :model="form" ref="formRef" label-width="100px">
        <el-form-item label="充值条数" prop="quantity">
          <el-input v-model="form.quantity" style="width: 240px" />
        </el-form-item>
        <el-form-item label="备注" prop="quantity">
          <el-input v-model="form.desc" type="textarea" style="width: 240px" />
        </el-form-item>
        <el-form-item>
          <el-button @click="handleRestForm">重置</el-button>
          <el-button type="primary" @click="submitForm">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="记录" v-model="recordVisible" @closed="handleRecordDialogClosed">
      <el-table :data="recordData" style="border: 1px solid #efefef;">
        <el-table-column label="短信条数" prop="quantity" />
        <el-table-column label="变化">
          <template #default="{row}">
            {{  row.type == 1 ? '充值' : '使用' }}
          </template>
        </el-table-column>
        <el-table-column label="原因" prop="desc" />
        <el-table-column label="时间" prop="CreatedAt" />
      </el-table>
      <div style="text-align: center; margin-top: 20px;">
      <el-pagination @current-change="currentChange" background layout="prev, pager, next" hide-on-single-page :total="recordTotal" v-model:current-page="recordPage" />
    </div>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>

</style>